// this file is automatically generated by git.version.ts script
/* tslint:disable */
export const versions = {commitDateTime: '2026-09-02T09:15:30+0200', version: '4.8.0', revision: '8e50ae988', branch: 'HEAD'};
 